// ContentFilters jQuery Plugin
// Filters all sort of content

$(function () {
    var ContentFilters = function (element, options) {
        this.contentFilters = $(element);

        // Default module configuration
        this.defaults = {
            labels: {
                label1: 'label1',
                label2: 'label2',
            },
            classes: {
                class1: 'class1',
                class2: 'class2',
                states: {
                    active: 'is-active',
                },
            },
        };

        // Merge default classes with window.project.classes
        this.classes = $.extend(true, this.defaults.classes, (window.project ? window.project.classes : {}));

        // Merge default labels with window.project.labels
        this.labels = $.extend(true, this.defaults.labels, (window.project ? window.project.labels : {}));

        // Merge default config with custom config
        this.config = $.extend(true, this.defaults, options || {});

        // Trigger and content
        this.contentFiltersTrigger = this.contentFilters.find('.content-filters-open-trigger');
        this.contentFiltersContent = this.contentFilters.find('.content-filters-fields');

        this.publicMethods = {
            methodName: $.proxy(function () {
                // console.log('methodName function called');
            }, this),
        };

        this.init();
    };

    $.extend(ContentFilters.prototype, {

        // Component initialization
        init: function () {
            // Desactivate trigger if not mobile
            if ($(window).width() > 767) {
                this.toggleFiltersVisible();
                this.contentFiltersTrigger.attr('disabled', true);
            }
            this.bindEvents();
        },

        bindEvents: function () {
            // Trigger open or close filters
            this.contentFiltersTrigger.on('click', $.proxy(function () {
                this.toggleFiltersVisible();
            }, this));
        },

        toggleFiltersVisible: function () {
            if (this.contentFiltersContent.hasClass(this.classes.states.active)) {
                this.contentFiltersTrigger.removeClass(this.classes.states.active);
                this.contentFiltersContent.removeClass(this.classes.states.active);
            } else {
                this.contentFiltersTrigger.addClass(this.classes.states.active);
                this.contentFiltersContent.addClass(this.classes.states.active);
            }
        },
    });

    $.fn.contentFilters = function (options) {
        this.each($.proxy(function (index, element) {
            var $element = $(element);

            // Return early if this $element already has a plugin instance
            if ($element.data('contentFilters')) return;

            // Pass options to plugin constructor
            var contentFilters = new ContentFilters(element, options);

            // Add every public methods to plugin
            for (var key in contentFilters.publicMethods) {
                this[key] = contentFilters.publicMethods[key];
            }

            // Store plugin object in this $element's data
            $element.data('contentFilters', contentFilters);
        }, this));

        return this;
    };
});
